var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowRightLight = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: _jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.2075 6.23214C13.4935 5.93252 13.9682 5.92148 14.2679 6.20748L19.7679 11.4575C19.9161 11.599 20 11.795 20 12C20 12.205 19.9161 12.401 19.7679 12.5425L14.2679 17.7925C13.9682 18.0785 13.4935 18.0675 13.2075 17.7679C12.9215 17.4682 12.9325 16.9935 13.2321 16.7075L17.3781 12.75H4.75C4.33579 12.75 4 12.4142 4 12C4 11.5858 4.33579 11.25 4.75 11.25H17.3781L13.2321 7.29252C12.9325 7.00651 12.9215 6.53177 13.2075 6.23214Z', fill: 'white' }) })));
};
export { ArrowRightLight };
//# sourceMappingURL=ArrowRightLight.js.map